export default __webpack_public_path__ + "images/to-65dda6ec6f9719bbd78463630e8470b6.svg";